/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the SDCCACoverageInfoDtls
 *
 * @class SDCCACoverageInfoDtls
 */
class SDCCACoverageInfoDtls {
  /**
   * Creates an instance of SDCCACoverageInfoDtls.
   * @param {*} json
   * @memberof SDCCACoverageInfoDtls
   */
  constructor(json = null) {
    if (json) {
      // string
      this.providerName = json.providerName;

      // number
      this.copayAmount = json.copayAmount;

      // number
      this.rateAmount = json.rateAmount;

      // number
      this.benefitAmount = json.benefitAmount;
    }
  }
}

/**
 * Models the SDHouseholdMemberCoverageInfoDtls
 *
 * @class SDHouseholdMemberCoverageInfoDtls
 */
class SDHouseholdMemberCoverageInfoDtls {
  /**
   * Creates an instance of SDHouseholdMemberCoverageInfoDtls.
   * @param {*} json
   * @memberof SDHouseholdMemberCoverageInfoDtls
   */
  constructor(json = null) {
    if (json) {
      // string
      this.firstForeName = json.firstForeName;

      // string
      this.lastName = json.lastName;

      // string
      this.endDate = json.endDate;

      // string
      this.coverageInfoMessageType = json.coverageInfoMessageType;

      // string
      this.startDate = json.startDate;

      // string
      this.sdccaProgramName = json.sdccaProgramName;

      // array - SDCCACoverageInfoDtls
      if (json.sdccaDtls) {
        this.sdccaDtls = json.sdccaDtls.map(object => new SDCCACoverageInfoDtls(object));
      } else if (json.constructor === Array) {
        this.sdccaDtls = json.map(object => new SDCCACoverageInfoDtls(object));
      }
    }
  }
}

/**
 * Models the SDExternalUserCoverageInfo
 *
 * @class SDExternalUserCoverageInfo
 */
class SDExternalUserCoverageInfo {
  /**
   * Creates an instance of SDExternalUserCoverageInfo.
   * @param {*} json
   * @memberof SDExternalUserCoverageInfo
   */
  constructor(json = null) {
    if (json) {
      // string
      this.lastUpdated = json.lastUpdated;

      // boolean
      this.hasActivePDCOnIC = json.hasActivePDCOnIC;

      // boolean
      this.hasClosedPDCWithInGracePeriod = json.hasClosedPDCWithInGracePeriod;

      // array - SDHouseholdMemberCoverageInfoDtls
      if (json.dtls) {
        this.dtls = json.dtls.map(object => new SDHouseholdMemberCoverageInfoDtls(object));
      } else if (json.constructor === Array) {
        this.dtls = json.map(object => new SDHouseholdMemberCoverageInfoDtls(object));
      }
    }
  }
}

export default {
  SDCCACoverageInfoDtls,

  SDHouseholdMemberCoverageInfoDtls,

  SDExternalUserCoverageInfo,
};
